import { useState } from "react";

import { LayoutPreferenceKey, layoutPreferencesStorage, useNavigationCollapse } from "@shared";

export function useLayout() {
  const { isNavigationCollapsed, handleNavigationCollapse, navigationWidth } = useNavigationCollapse();

  const [isDropZoneOpen, setIsDropZoneOpen] = useState<boolean>(
    () => layoutPreferencesStorage.get(LayoutPreferenceKey.DropZoneOpen) ?? false
  );

  const toggleDropZone = () => {
    setIsDropZoneOpen((prev) => {
      const next = !prev;
      layoutPreferencesStorage.set(LayoutPreferenceKey.DropZoneOpen, next);
      return next;
    });
  };

  return {
    isNavigationCollapsed,
    handleNavigationCollapse,
    navigationWidth,
    isDropZoneOpen,
    toggleDropZone,
  };
}
